import { apiClient, schoolApiClient } from '../apiClients';
import { Endpoints } from '../../network';
import {
  ILiveRegistrationAlreadyRegistered,
  ReqCommentData,
} from '../../utils/interfaces/Live';

export const getCurrentLive = async (keyword?: string) => {
  const queryParams = new URLSearchParams({
    type: 'current',
    ...(keyword !== undefined && keyword !== '' && { search: keyword }),
  });
  const urlWithQuery = `${Endpoints.getCurrentLive}?${queryParams}`;

  const response = await schoolApiClient.get(urlWithQuery);
  return response?.data;
};

export const getUpcomingLive = async ({
  keyword,
  page,
  category,
}: {
  keyword?: string;
  page?: number;
  category?: string;
}) => {
  const queryParams = new URLSearchParams({
    type: 'upcoming',
    ...(category !== undefined && { category: category.toString() }),
    ...(page !== undefined && { page: page.toString() }),
    ...(keyword !== undefined && keyword !== '' && { search: keyword }),
  });
  const urlWithQuery = `${Endpoints.getCurrentLive}?${queryParams}`;
  const response = await schoolApiClient.get(urlWithQuery);
  return response?.data;
};

export const getSingleOngoingLive = async () => {
  const response = await schoolApiClient.get(Endpoints.getSingleOngoingLive);
  return response?.data;
};

export const getLiveDetails = async (slug: string) => {
  const response = await schoolApiClient.get(Endpoints.getLiveDetails + slug);
  return response?.data;
};

export const getLiveSessionById = async (id: string) => {
  const response = await schoolApiClient.get(
    `${Endpoints.getLiveDetails}${id}`,
  );
  return response?.data;
};

export const getCommentsBySessionId = async (sessionId: number) => {
  const response = await schoolApiClient.get(
    Endpoints.getSessionCommentBySessionId +
      `?commentable_type=zl_live&commentable_id=${sessionId}&perPage=500`,
  );
  return response?.data;
};

export const postComment = async (payload: ReqCommentData) => {
  const response = await schoolApiClient.post(Endpoints.postComment, payload);
  return response?.data;
};

export const getLiveBanner = async (status: string) => {
  const response = await schoolApiClient.get(
    `${Endpoints.getLiveBanner}?status=${status}`,
  );
  return response?.data;
};

export const liveRegistrationAlreadyRegistered = async (
  body: ILiveRegistrationAlreadyRegistered,
) => {
  const response = await schoolApiClient.post(
    `${Endpoints.liveRegistrationAlreadyRegistered}`,
    {
      live_id: body?.live_workshop_slug,
      phone: body?.phone,
      country_code: body?.country_code,
    },
  );
  return response?.data;
};

export const updateUserPhoneNumber = async (updateUserPhone: {
  phone: string;
  country_code: string;
}) => {
  const response = await apiClient.post(`${Endpoints.updateUserPhone}`, {
    ...updateUserPhone,
  });
  return response?.data;
};
